import { getLLTtoken } from "./getLLT";

export const getClientCode = () => {

  const cookieToken = getLLTtoken()

  if (!cookieToken) {
    console.error("Token not found in cookies");
    return null;
  }
  try {
    const payloadBase64Url = cookieToken.split(".")[1];

    if (!payloadBase64Url) {
      console.error("Invalid token format");
      return null;
    }

    const payloadBase64 = payloadBase64Url
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const payloadJson = decodeURIComponent(
      atob(payloadBase64)
        .split("")
        .map((char) => "%" + ("00" + char.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    const payload = JSON.parse(payloadJson);

    return payload.clientCode || null;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
}